import { render, staticRenderFns } from "./BillingList.vue?vue&type=template&id=b3b88d66&scoped=true&"
import script from "./BillingList.vue?vue&type=script&lang=js&"
export * from "./BillingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b88d66",
  null
  
)

export default component.exports